import DatricRequests from '../datric.requests';

const requests = new DatricRequests();

export interface LoginPayload {
	email: string;
	password: string;
}

export interface LoginResponse {
	accessToken: string;
	userName: string;
	role: string;
	balance: number;
	pricePerQuery?: number;
	// Leilão liberado para este cliente: define se a tela aparece no menu.
	leilaoEnabled?: boolean;
	// Idem para o Lead ao Vivo (a liberação mora na config da feature).
	liveLeadEnabled?: boolean;
}

export async function login(payload: LoginPayload): Promise<LoginResponse> {
	return requests.post('auth/login', payload);
}

export interface MeResponse {
	id: string;
	name: string;
	email: string;
	role: string;
	balance: number;
	pricePerQuery?: number;
	leilaoEnabled?: boolean;
	liveLeadEnabled?: boolean;
	active?: boolean;
}

export async function me(): Promise<MeResponse> {
	return requests.get('me');
}
